"use client";

import { useEffect, useState } from "react";
import dayjs from "dayjs";
import BgLatto from "../../assets/images/bg-keypad.png";

export default function DrawTimer({ drawTime, drawDate }) {
  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());
  function calculateTimeLeft() {
    const now = dayjs();
    const today = dayjs().format('YYYY-MM-DD');
    const targetTime = dayjs(`${today} ${drawTime}`);
    
    if (targetTime.isBefore(now)) {
      const tomorrow = dayjs().add(1, 'day').format('YYYY-MM-DD');
      const nextTarget = dayjs(`${tomorrow} ${drawTime}`);
      const diff = nextTarget.diff(now, "seconds");
      return {
        hours: Math.floor(diff / 3600),
        minutes: Math.floor((diff % 3600) / 60),
        seconds: diff % 60,
      };
    }

    const diff = targetTime.diff(now, "seconds");
    return {
      hours: Math.floor(diff / 3600),
      minutes: Math.floor((diff % 3600) / 60),
      seconds: diff % 60,
    };
  }

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);

    return () => clearInterval(timer);
  }, [drawTime]);

  return (
    <div className="flex justify-between items-center rounded-lg px-2.5 py-3 mx-4 border border-white"
      style={{
        backgroundImage: `url(${BgLatto})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <div>
        <div className="flex items-center gap-1">
          <div className="text-white text-3xl font-semibold">OPEN</div>
          <div className="text-[#FFE500] text-[12px] leading-none font-semibold">
            {drawTime ? dayjs(`2024-01-01 ${drawTime}`).format("hA").toUpperCase() : "Invalid Time"} <br /> DRAW
          </div>
        </div>
        <div className="text-[#6D7388] text-xs leading-none">{drawDate}</div>
      </div>
      <div className="flex gap-1.5">
        <TimeBox value={timeLeft.hours} label="Hour" />
        <TimeBox value={timeLeft.minutes} label="Minute" />
        <TimeBox value={timeLeft.seconds} label="Second" />
      </div>
    </div>
  );
}

function TimeBox({ value, label }) {
  return (
    <div className="bg-white rounded w-12 h-[50px] flex items-center justify-center flex-col">
      <div className="text-2xl font-semibold mt-0.5">
        {isNaN(value) ? "-" : value.toString().padStart(2, "0")}
      </div>
      <div className="text-[10px] mb-1">{label}</div>
    </div>
  );
}
